<template>
  <div class="share-widget">
    <button @click="onCopy"><icon name="copy" />{{ $t('shareWidget.copyLabel') }}</button>
    <div class="small-text"><span v-if="copied">{{ $t('shareWidget.copiedMessage') }}</span><span v-else>&nbsp;</span></div>
  </div>
</template>

<script>
  import i18n from '../i18n';

  export default {
    scaifeConfig: {
      displayName: () => i18n.t('shareWidget.title'),
    },
    data() {
      return {
        copied: false,
      };
    },
    methods: {
      getReaderUrl() {
        const readers = document.querySelectorAll('.reader');
        const urns = Array.from(readers).map((reader) => {
          const workSelectorRect = reader.querySelector('.reader-header').getBoundingClientRect();
          const lines = reader.querySelectorAll('.section-line');
          const line = Array.from(lines).find(l => l.getBoundingClientRect().top >= workSelectorRect.bottom);
          console.log(`${reader.dataset.workUrn}:${line.dataset.sectionIdx}.${line.dataset.lineIdx}`);
          return `${reader.dataset.workUrn}:${line.dataset.sectionIdx}.${line.dataset.lineIdx}`;
        });
        const readerUrl = this.$router.resolve({
          name: 'reader',
          query: {
            urn: urns,
          },
        });
        return `${window.location.origin}${readerUrl.href}`;
      },
      onCopy() {
        this.$clipboard(this.getReaderUrl());
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 5000);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../_variables.scss";

  #app[data-locale="ar"] .share-widget {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
  button {
    cursor: pointer;
    display: block;
    font-size: 12pt;
    background: $white;
    border: 1px solid $gray-400;
    border-radius: 3px;
    padding: 0.75rem 2.5rem;
    width: 100%;
    &:hover {
      color: $white;
      background: $brand;
      border-color: lighten($brand, 20);
    }
  }
  .share-widget {
    margin: 20px 10px 5px 10px;
    .small-text {
      font-size: 70%;
      color: $gray-600;
      text-align: center;
      padding-top: 5px;
    }
  }
  #app[data-locale="ar"] .share-widget {
  }

</style>
